<template>
  <div
    id="ooo_banner"
    class="p-2
      has-text-weight-medium is-size-6
      is-flex is-align-items-center is-justify-content-center"
    style="height: 100%; width: 100%; position: relative">
    <p>{{ client.attributes.ooo_note || $t('client.labels.outOfOffice') }}</p>
    <ButtonLight
      v-if="profile.type === PROFILE_TYPES.EMPLOYEE && !is_client_settings_page"
      :class="isMobile ? '' : 'ml-6'"
      :is_outlined="true"
      :to="{ name: ROUTES_EMPLOYEES.CLIENT_SETTINGS }">
      {{ $t('client.labels.goToSettings') }}
    </ButtonLight>
  </div>
</template>

<script>

import { ROUTES_EMPLOYEES } from '@/app/data/route_constants';
import { PROFILE_TYPES } from '@/app/data/model_constants';

export default {
  name: 'TheOutOfOfficeBanner',
  props: {
    client: { type: Object, required: true },
    profile: { type: Object, required: true },
  },
  data() {
    return {
      ROUTES_EMPLOYEES,
      PROFILE_TYPES,
    };
  },
  computed: {
    is_client_settings_page() {
      return this.$route.name === ROUTES_EMPLOYEES.CLIENT_SETTINGS;
    },
  },
};
</script>
